<!-- #region Slider -->
<app-home-slider [ngClass]="lang"></app-home-slider>
<!-- #endregion -->

<!-- #region About -->
<section [ngClass]="lang" class="about p-5">
  <div class="container">
    <div class="row">
      <img src="../../../../assets/images/logo/logo.svg" alt="About" [class.fadeInLeft]="lang=='en'"
        [class.fadeInRight]="lang=='ar'" class="col-md-5 col-sm-12 wow p-1" data-wow-delay="0s"
        (load)="onLoading('About')">
      <div [id]="'About'" class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div *ngIf="lang=='en'" class="col-md-7 col-sm-12 m-auto wow fadeInRightBig" data-wow-delay="0s">
        <h2>
          About us
        </h2>
        <p class="text-justify">
          Company Ltd. has been established in Riyadh, Saudi Arabia since 2001. Our vision has been to be a leading company
          providing innovative technology solutions for businesses in the Kingdom of Saudi Arabia and countries with
          developing and stable economies in the region. During our years of success and rapid growth, our company has
          established several regional offices. The company was established in 2017.
        </p>
      </div>
      <div *ngIf="lang=='ar'" class="col-md-7 col-sm-12 m-auto wow fadeInLeft" data-wow-delay="0s">
        <h2>
          نبذة
        </h2>
        <p class="text-justify">
          تاسست شركة الشركة القابضة في مدينة الرياض بالمملكة العربية السعودية منذ العام 2001، لقد كانت رؤيتنا منذ البدء ان
          نكون شركة رائدة تقدم حلول تقنية مبتكرة للاعمال في المملكة و البلدان ذات الاقتصادات النامية والمستقرة في
          المنطقة. خلال سنوات النجاح الذي حققناه والنمو المتسارع , اسست الشركة عدة أفرع اقليمية وتم تاسيس شركة الشركة
          السودان ف العام 2017 .
        </p>
      </div>
    </div>
  </div>
</section>
<!-- #endregion -->

<!-- #region Info Company -->
<section [ngClass]="lang" class="Info p-5">
  <div class="container">
    <div class="row">

      <!-- Start Vision -->
      <div *ngIf="lang=='en'" class="col-md-4 p-3 wow fadeInLeft p-4" data-wow-delay="0.1s">
        <img src="../../../../assets/images/items/Vision.svg" alt="Vision" class="col-12" (load)="onLoading('vision')">
        <div [id]="'vision'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h2 class="text-center">
          Our vision
        </h2>
        <p class="text-justify">
          To be one of the leading companies in Africa and the Middle East provide innovative technical solutions and
          provide technical consultancy for the development and implementation of services
        </p>
      </div>

      <div *ngIf="lang=='ar'" class="col-md-4 p-3 wow fadeInLeft p-4" data-wow-delay="0.1s">
        <img src="../../../../assets/images/items/Vision.svg" alt="Vision" class="col-12" (load)="onLoading('vision2')">
        <div [id]="'vision2'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h2 class="text-center">
          رؤيتنا
        </h2>
        <p class="text-justify">
          أن نكون احدى الشركات الرائدة في أفريقيا و الشرق الأوسط توفر حلول تقنيية مبتكرة وتقدم استشارات التقنيية.
        </p>
      </div>
      <!-- End Vision -->

      <!-- Start Mission -->
      <div *ngIf="lang=='en'" class="col-md-4 p-3 wow fadeInUp p-4" data-wow-delay="0.15s">
        <img src="../../../../assets/images/items/Mission.svg" alt="Mission" class="col-12"
          (load)="onLoading('Mission')">
        <div [id]="'Mission'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h2 class="text-center">
          Our mission
        </h2>
        <p class="text-justify">
          Enhance customer core business and improve productivity by providing them with comprehensive technical
          solutions supported by training and high quality services.
        </p>
      </div>

      <div *ngIf="lang=='ar'" class="col-md-4 p-3 wow fadeInUp p-4" data-wow-delay="0.15s">
        <img src="../../../../assets/images/items/Mission.svg" alt="Mission" class="col-12"
          (load)="onLoading('Mission2')">
        <div [id]="'Mission2'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h2 class="text-center">
          مهمتنا
        </h2>
        <p class="text-justify">
          تعزيز الأعمال التجارية الأساسية للعملاء وتحسين الإنتاجيتهم من خلال تزويدهم بحلول تقنية شاملة مدعّمة بالتدريب و
          الخدمات العالية الجودة.
        </p>
      </div>
      <!-- End Mission -->

      <!-- Start Value -->
      <div *ngIf="lang=='en'" class="col-md-4 p-3 wow fadeInRight p-4" data-wow-delay="0.2s">
        <img src="../../../../assets/images/items/Value.svg" alt="Value" class="col-12" (load)="onLoading('Value')">
        <div [id]="'Value'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h2 class="text-center">
          Our massage
        </h2>

        <p class="text-justify">
          Offering unique solutions of high quality and the highest international standards in the field of IT to
          support customers in achieving their strategic objectives
        </p>

      </div>
      <div *ngIf="lang=='ar'" class="col-md-4 p-3 wow fadeInRight p-4" data-wow-delay="0.2s">
        <img src="../../../../assets/images/items/Value.svg" alt="Value" class="col-12" (load)="onLoading('Value2')">
        <div [id]="'Value2'" class="spinner-grow text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <h2 class="text-center">
          رسالتنا
        </h2>

        <p class="text-justify">
          تقديم حلول فريدة من نوعها ذات جودة عالية بمعايير عالمية في مجال تقنية المعلومات لندعم عملاءنا لتحقيق أهدافهم
          الإستراتيجية.
        </p>

      </div>
      <!-- End Value -->
    </div>
  </div>
</section>
<!-- #endregion -->

<!-- #region services -->
<app-home-services [ngClass]="lang"></app-home-services>
<!-- #endregion -->

<app-pricing [ngClass]="lang"></app-pricing>

<!-- #region customer -->
<app-customer [ngClass]="lang"></app-customer>
<!-- #endregion -->

<!-- #region Contact Us -->
<app-contactus></app-contactus>
<!-- #endregion -->

<!-- #region footer -->
<app-footer></app-footer>
<!-- #endregion -->
